var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule"},[_c('Title',{staticStyle:{"margin-bottom":"10px"}},[_vm._v("活动规则")]),_c('div',{staticClass:"main"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.rulesData)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }